export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5365.3a63e292.jpg";